'use strict'

const ref = (
  resourceType,
  legacyKey,
  publicKey,
  internalKey = legacyKey,
  options = {}
) => ({
  resourceType,
  legacyKey,
  publicKey,
  internalKey,
  ...options
})

const LEGACY_PATH_POLICIES = {
  'ユーザ詳細': {
    publicRouteName: 'PublicUserDetail',
    references: [ref('USER', 'id', 'user_ref')]
  },
  'ユーザ更新': {
    publicRouteName: 'PublicUserUpdate',
    references: [ref('USER', 'id', 'user_ref')]
  },
  '部署詳細': {
    publicRouteName: 'PublicDepartmentDetail',
    references: [ref('DEPARTMENT', 'id', 'department_ref')]
  },
  '部署更新': {
    publicRouteName: 'PublicDepartmentUpdate',
    references: [ref('DEPARTMENT', 'id', 'department_ref')]
  },
  '休暇申請詳細': {
    publicRouteName: 'PublicPaidLeaveDetail',
    references: [ref('PAID_LEAVE', 'id', 'paid_leave_ref')]
  },
  '休暇申請修正': {
    publicRouteName: 'PublicPaidLeaveEdit',
    references: [ref('PAID_LEAVE', 'id', 'paid_leave_ref')]
  },
  '予定外時間外報告詳細': {
    publicRouteName: 'PublicOvertimeDetail',
    references: [ref('OVERTIME', 'id', 'overtime_ref')]
  },
  '予定外時間外報告修正': {
    publicRouteName: 'PublicOvertimeEdit',
    references: [ref('OVERTIME', 'id', 'overtime_ref')]
  },
  '休日出勤報告詳細': {
    publicRouteName: 'PublicHolidayWorkDetail',
    references: [ref('HOLIDAY_WORK', 'id', 'holiday_work_ref')]
  },
  '休日出勤報告修正': {
    publicRouteName: 'PublicHolidayWorkEdit',
    references: [ref('HOLIDAY_WORK', 'id', 'holiday_work_ref')]
  },
  'プロジェクト検索詳細': {
    publicRouteName: 'PublicProjectSearchDetail',
    references: [ref('PROJECT', 'id', 'project_ref')]
  },
  '業務報告詳細': {
    publicRouteName: 'PublicAdminMonthlyReportDetail',
    references: [
      ref('MONTHLY_REPORT', 'id', 'report_ref'),
      ref('USER', 'user_id', 'user_ref')
    ]
  },
  '勤務表詳細': {
    publicRouteName: 'PublicAdminRosterDetail',
    references: [
      ref('USER', 'user_id', 'user_ref', 'user_id', { labelKey: 'user_name' })
    ],
    dropParams: ['user_name']
  },
  '休暇申請詳細(管理者)': {
    publicRouteName: 'PublicAdminPaidLeaveDetail',
    references: [ref('PAID_LEAVE', 'id', 'paid_leave_ref')]
  },
  '予定外時間外報告詳細(管理者)': {
    publicRouteName: 'PublicAdminOvertimeDetail',
    references: [ref('OVERTIME', 'id', 'overtime_ref')]
  },
  '休日出勤報告詳細(管理者)': {
    publicRouteName: 'PublicAdminHolidayWorkDetail',
    references: [ref('HOLIDAY_WORK', 'id', 'holiday_work_ref')]
  },
  '経費精算詳細(管理者)': {
    publicRouteName: 'PublicAdminExpenseDetail',
    references: [ref('USER', 'user_id', 'user_ref')]
  },
  '通勤費精算詳細(管理者)': {
    publicRouteName: 'PublicAdminTravelCostDetail',
    references: [ref('USER', 'user_id', 'user_ref')]
  }
}

const PUBLIC_PATH_POLICIES = Object.keys(LEGACY_PATH_POLICIES).reduce((result, legacyName) => {
  const value = LEGACY_PATH_POLICIES[legacyName]
  result[value.publicRouteName] = {
    legacyRouteName: legacyName,
    publicRouteName: value.publicRouteName,
    references: value.references,
    dropParams: value.dropParams || []
  }
  return result
}, {})

const QUERY_POLICIES = {
  'プロジェクト詳細': {
    references: [ref('PROJECT', 'id', 'id')]
  },
  'プロジェクト更新': {
    references: [ref('PROJECT', 'id', 'id')]
  },
  'クライアント詳細': {
    references: [ref('CLIENT', 'id', 'id')]
  },
  'クライアント更新': {
    references: [ref('CLIENT', 'id', 'id')]
  },
  ProjectPrerequisiteRequired: {
    optional: true,
    references: [ref('USER', 'targetUserId', 'targetRef', 'targetUserId')]
  }
}

export function publicRouteReferencePolicy (route) {
  const name = route && route.name
  if (!name) return null

  if (LEGACY_PATH_POLICIES[name]) {
    return {
      mode: 'legacy-path',
      legacyRouteName: name,
      ...LEGACY_PATH_POLICIES[name]
    }
  }
  if (PUBLIC_PATH_POLICIES[name]) {
    return {
      mode: 'public-path',
      ...PUBLIC_PATH_POLICIES[name]
    }
  }
  if (QUERY_POLICIES[name]) {
    return {
      mode: 'query',
      legacyRouteName: name,
      publicRouteName: name,
      ...QUERY_POLICIES[name]
    }
  }
  return null
}

export const publicRouteNames = Object.freeze(
  Object.keys(PUBLIC_PATH_POLICIES)
)

export const legacyRouteNames = Object.freeze(
  Object.keys(LEGACY_PATH_POLICIES)
)
